import {AfterViewInit, Component, Input} from '@angular/core';
import {BaseComponent} from "common-shared";
import {ActivatedRoute, Router} from "@angular/router";
import {BreadCrumb} from "../action-bar.component";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styles: [],
  host: {
    class: 'd-flex'
  }
})
export class BreadcrumbsComponent extends BaseComponent implements AfterViewInit {
  breadCrumbs: Array<BreadCrumb>;
  @Input() extraBreadCrumbs: Array<BreadCrumb> = [];
  @Input() useRouteBasedBreadCrumbs: boolean = true;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    super();
    this.buildBreadCrumb(this.activatedRoute);
  }

  ngAfterViewInit(): void {
    this.router.events.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.buildBreadCrumb(this.activatedRoute);
    });
  }

  buildBreadCrumb(route: ActivatedRoute) {
    // If no routeConfig is available we are on the root path
    let breadCrumbs: BreadCrumb[] = [];
    if(this.useRouteBasedBreadCrumbs){
      let routes = [];

      while (route) {
        routes.push(route);
        route = route.parent;
      }
      routes = [...routes.reverse()];

      for (let route1 of routes) {
        let byRoute = this.getByRoute(route1, breadCrumbs);
        if (byRoute) {
          breadCrumbs.push(byRoute);
        }
      }
    }

    this.breadCrumbs = breadCrumbs.filter(value => value.label);

    // if (route.firstChild) {
    //   // If we are not on our current path yet,
    //   // there will be more children to look after, to build our breadcumb
    //   //return this.buildBreadCrumb(route.firstChild, nextUrl, breadcrumbs);
    // }

  }

  private getByRoute(route: ActivatedRoute, breadCrumbs: BreadCrumb[]) {
    const path = route.routeConfig ? route.routeConfig.path : '';
    // In the routeConfig the complete path is not available,
    // so we rebuild it each time

    let s = breadCrumbs.map(value => value.url).join('/');

    const nextUrl = `${s}/${path}`;

    let breadcrumb: BreadCrumb;
    if (route.routeConfig) {
      const label = route.routeConfig && route.routeConfig.data ? route.routeConfig.data['breadcrumb'] : undefined;
      breadcrumb = {
        label: label,
        url: nextUrl
      };

      route.params.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        for (const paramsKey of Object.keys(value)) {
          breadcrumb.url = breadcrumb.url.replace(':' + paramsKey, '');
        }
        breadcrumb.params = Object.keys(value).map(key => value[key]);
      });

      breadcrumb.url = breadcrumb.url.replace(/\/*$/, '');
    }
    return breadcrumb;
  }

  getRouteParams(breadcrumb: BreadCrumb) {
    let params = [];
    if (breadcrumb.url) {
      params = [breadcrumb.url];
    }

    if (breadcrumb.params?.length) {
      params = [...params, breadcrumb.params.join('/')];
    }
    return params;
  }
}
